import { render, staticRenderFns } from "./ProductCategoryDeleteDrawer.vue?vue&type=template&id=421e8c3e&scoped=true"
import script from "./ProductCategoryDeleteDrawer.vue?vue&type=script&lang=js"
export * from "./ProductCategoryDeleteDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421e8c3e",
  null
  
)

export default component.exports